























import { Component, Prop, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import { emitOpenArticle } from '@/common/eventBus';
import loading from '@/components/loading';

@Component({
  components: {
    Header,
  },
  directives: {
    loading,
  },
})
export default class Article extends Vue {
  @Prop({ default: '' }) readonly articleId!: string;
  @Prop({ default: '' }) readonly title!: string;
  @Prop({ default: '' }) readonly body!: string;
  @Prop({ default: '' }) readonly sectionTitle!: string;

  articleTitle = '';
  loading = false;

  created () {
    window.history.pushState('forward', '', 'article'); // For handling Back button

    const backListener = () => {
      emitOpenArticle({
        isOpen: false,
      });
      window.removeEventListener('popstate', backListener);
    };
    window.addEventListener('popstate', backListener);
  }

  destroyed () {
    const container = document.getElementById('messageListContainer');
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  }

  backCallback () {
    history.back(); // To trigger popState listener
  }
}
